import FirestoreModel from '../models/firestore-model';
import { collections } from '../models/firestore-model';

class AllLogsService extends FirestoreModel {
  constructor() {
    super(collections.alllogs);
  }
}

export default new AllLogsService();